import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.CEC001.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    RS <CheckCSName csName={x.cross_section} />, which is the #{x.number} XS of the {x.type} at RS {x.culvert}, do not have the recommended contraction/expansion coefficients of {settings?.defaults?.cont_coef_structure_xs}/{settings?.defaults?.exp_coef_structure_xs}.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.CEC002.error_id: {
            return (
                <>
                    <ResultText>Contraction/expansion coefficients are different than the recommended values of {`${settings?.defaults?.cont_coef_natural_xs}/${settings?.defaults?.exp_coef_natural_xs}`} at the following {row?.data?.length} natural cross sections:</ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const B4 = {
    RenderDescription,
}